import { render, staticRenderFns } from "./HeaderWithPic.vue?vue&type=template&id=1311d318&scoped=true&"
import script from "./HeaderWithPic.vue?vue&type=script&lang=ts&"
export * from "./HeaderWithPic.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderWithPic.vue?vue&type=style&index=0&id=1311d318&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311d318",
  null
  
)

export default component.exports